module.exports = __webpack_public_path__ + "static/media/bitcoin.d70c756f.png";